/*
 * ANTE VINTAGE TOKYO
 * Search Dictionary V3
 * Japanese + English Unified Dictionary
 *
 * 検索エンジン側で自動吸収:
 * - 大文字 / 小文字
 * - 全角 / 半角
 * - スペース有無
 * - ハイフン / 中黒
 * - アクセント記号
 *
 * この辞書では主に
 * 「別名・略称・日本語/英語名称」を管理する。
 */

window.ANTE_SEARCH_DICTIONARY = {

  /* =========================================================
     BRANDS
     ========================================================= */

  brands: [
    {
      id: "cartier",
      canonical: "Cartier",
      aliases: [
        "カルティエ",
        "Cartier"
      ]
    },

    {
      id: "jaeger-lecoultre",
      canonical: "Jaeger LeCoultre",
      aliases: [
        "ジャガールクルト",
        "ジャガー ルクルト",
        "ルクルト",
        "Jaeger LeCoultre",
        "Jaeger-LeCoultre",
        "Jaeger Lecoultre",
        "LeCoultre",
        "JLC"
      ]
    },

    {
      id: "franck-muller",
      canonical: "Franck Muller",
      aliases: [
        "フランクミュラー",
        "フランク ミュラー",
        "フランク",
        "Franck Muller",
        "Frank Muller",
        "Franck",
        "Frank"
      ]
    },

    {
      id: "rolex",
      canonical: "Rolex",
      aliases: [
        "ロレックス",
        "Rolex"
      ]
    },

    {
      id: "patek-philippe",
      canonical: "Patek Philippe",
      aliases: [
        "パテックフィリップ",
        "パテック フィリップ",
        "パテック",
        "Patek Philippe",
        "Patek"
      ]
    },

    {
      id: "hermes",
      canonical: "Hermes",
      aliases: [
        "エルメス",
        "Hermes",
        "Hermès"
      ]
    }
  ],


  /* =========================================================
     MODELS
     ========================================================= */

  models: [

    /* ================= CARTIER ================= */

    {
      id: "panthere",
      brand: "cartier",
      canonical: "Panthere",
      aliases: [
        "パンテール",
        "Panthere",
        "Panthère",
        "Cartier Panthere",
        "Cartier Panthère"
      ]
    },

    {
      id: "panthere-cougar",
      brand: "cartier",
      canonical: "Panthere Cougar",
      aliases: [
        "パンテールクーガ",
        "クーガ",
        "Panthere Cougar",
        "Panthère Cougar",
        "Cougar"
      ]
    },

    /* MUST */

    {
      id: "must-tank",
      brand: "cartier",
      canonical: "Must Tank",
      aliases: [
        "マストタンク",
        "Must Tank",
        "Must de Cartier Tank",
        "Cartier Must Tank"
      ]
    },

    {
      id: "pre-must-tank",
      brand: "cartier",
      canonical: "Pre Must Tank",
      aliases: [
        "プレマストタンク",
        "プレマスト",
        "Pre Must Tank",
        "Pre-Must Tank",
        "Pre Must",
        "Pre-Must",
        "Pre Must Cartier"
      ]
    },

    /* TANK */

    {
      id: "tank-louis",
      brand: "cartier",
      canonical: "Tank Louis",
      aliases: [
        "タンクルイ",
        "タンクルイカルティエ",
        "ルイ",
        "Tank Louis",
        "Tank Louis Cartier",
        "Louis Cartier",
        "Louis Cartier Tank",
        "Cartier Tank Louis",
        "TLC"
      ]
    },

    {
      id: "tank-francaise",
      brand: "cartier",
      canonical: "Tank Francaise",
      aliases: [
        "タンクフランセーズ",
        "フランセーズ",
        "Tank Francaise",
        "Tank Française",
        "Francaise",
        "Française",
        "Cartier Tank Francaise",
        "Cartier Tank Française",
        "French Tank"
      ]
    },

    {
      id: "tank-americaine",
      brand: "cartier",
      canonical: "Tank Americaine",
      aliases: [
        "タンクアメリカン",
        "アメリカン",
        "Tank Americaine",
        "Tank Américaine",
        "Americaine",
        "Américaine",
        "Cartier Tank Americaine"
      ]
    },

    {
      id: "tank-anglaise",
      brand: "cartier",
      canonical: "Tank Anglaise",
      aliases: [
        "タンクアングレーズ",
        "アングレーズ",
        "Tank Anglaise",
        "Anglaise",
        "Cartier Tank Anglaise"
      ]
    },

    {
      id: "tank-basculante",
      brand: "cartier",
      canonical: "Tank Basculante",
      aliases: [
        "タンクバスキュラント",
        "バスキュラント",
        "Tank Basculante",
        "Basculante",
        "Cartier Tank Basculante"
      ]
    },

    {
      id: "tank-solo",
      brand: "cartier",
      canonical: "Tank Solo",
      aliases: [
        "タンクソロ",
        "Tank Solo",
        "Cartier Tank Solo"
      ]
    },

    /* BAIGNOIRE */

    {
      id: "baignoire",
      brand: "cartier",
      canonical: "Baignoire",
      aliases: [
        "ベニュワール",
        "Baignoire",
        "Cartier Baignoire"
      ]
    },

    {
      id: "baignoire-allongee",
      brand: "cartier",
      canonical: "Baignoire Allongee",
      aliases: [
        "ベニュワールアロンジェ",
        "アロンジェ",
        "Baignoire Allongee",
        "Baignoire Allongée",
        "Allongee",
        "Allongée"
      ]
    },

    /* SANTOS */

    {
      id: "santos-galbee",
      brand: "cartier",
      canonical: "Santos Galbee",
      aliases: [
        "サントスガルベ",
        "ガルベ",
        "Santos Galbee",
        "Santos Galbée",
        "Galbee",
        "Galbée"
      ]
    },

    {
      id: "santos-octagon",
      brand: "cartier",
      canonical: "Santos Octagon",
      aliases: [
        "サントスオクタゴン",
        "オクタゴン",
        "Santos Octagon",
        "Octagon"
      ]
    },

    {
      id: "santos-demoiselle",
      brand: "cartier",
      canonical: "Santos Demoiselle",
      aliases: [
        "サントスドゥモワゼル",
        "サントスデモワゼル",
        "ドゥモワゼル",
        "デモワゼル",
        "Santos Demoiselle",
        "Demoiselle"
      ]
    },

    {
      id: "santos-dumont",
      brand: "cartier",
      canonical: "Santos Dumont",
      aliases: [
        "サントスデュモン",
        "デュモン",
        "Santos Dumont",
        "Santos-Dumont",
        "Dumont"
      ]
    },

    /* OTHER CARTIER */

    {
      id: "ballon-bleu",
      brand: "cartier",
      canonical: "Ballon Bleu",
      aliases: [
        "バロンブルー",
        "バロン",
        "Ballon Bleu",
        "Ballon"
      ]
    },

    {
      id: "tortue",
      brand: "cartier",
      canonical: "Tortue",
      aliases: [
        "トーチュ",
        "Tortue"
      ]
    },

    {
      id: "trinity",
      brand: "cartier",
      canonical: "Trinity",
      aliases: [
        "トリニティ",
        "Trinity"
      ]
    },

    {
      id: "roadster",
      brand: "cartier",
      canonical: "Roadster",
      aliases: [
        "ロードスター",
        "Roadster"
      ]
    },

    {
      id: "vendome",
      brand: "cartier",
      canonical: "Vendome",
      aliases: [
        "ヴァンドーム",
        "ベンドーム",
        "Vendome",
        "Vendôme"
      ]
    },

    {
      id: "colisee",
      brand: "cartier",
      canonical: "Colisee",
      aliases: [
        "コリゼ",
        "Colisee",
        "Colisée"
      ]
    },

    {
      id: "pasha",
      brand: "cartier",
      canonical: "Pasha",
      aliases: [
        "パシャ",
        "Pasha"
      ]
    },

    {
      id: "diabolo",
      brand: "cartier",
      canonical: "Diabolo",
      aliases: [
        "ディアボロ",
        "Diabolo"
      ]
    },

    {
      id: "tonneau",
      brand: "cartier",
      canonical: "Tonneau",
      aliases: [
        "トノー",
        "Tonneau"
      ]
    },

    {
      id: "ronde",
      brand: "cartier",
      canonical: "Ronde",
      aliases: [
        "ロンド",
        "Ronde"
      ]
    },


    /* ================= JAEGER-LECOULTRE ================= */

    {
      id: "reverso",
      brand: "jaeger-lecoultre",
      canonical: "Reverso",
      aliases: [
        "レベルソ",
        "Reverso",
        "JLC Reverso",
        "Jaeger Reverso",
        "Jaeger LeCoultre Reverso",
        "Jaeger-LeCoultre Reverso",
        "LeCoultre Reverso"
      ]
    },

    {
      id: "reverso-duetto",
      brand: "jaeger-lecoultre",
      canonical: "Reverso Duetto",
      aliases: [
        "レベルソデュエット",
        "デュエット",
        "Reverso Duetto",
        "Duetto",
        "JLC Reverso Duetto"
      ]
    },

    {
      id: "reverso-classique",
      brand: "jaeger-lecoultre",
      canonical: "Reverso Classique",
      aliases: [
        "レベルソクラシック",
        "Reverso Classique",
        "JLC Reverso Classique"
      ]
    },


    /* ================= FRANCK MULLER ================= */

    {
      id: "casablanca",
      brand: "franck-muller",
      canonical: "Casablanca",
      aliases: [
        "カサブランカ",
        "Casablanca",
        "Franck Muller Casablanca",
        "Frank Muller Casablanca"
      ]
    },

    {
      id: "long-island",
      brand: "franck-muller",
      canonical: "Long Island",
      aliases: [
        "ロングアイランド",
        "Long Island",
        "LongIsland"
      ]
    },

    {
      id: "tonneau-curvex",
      brand: "franck-muller",
      canonical: "Tonneau Curvex",
      aliases: [
        "トノーカーベックス",
        "カーベックス",
        "Tonneau Curvex",
        "Curvex"
      ]
    },

    {
      id: "color-dreams",
      brand: "franck-muller",
      canonical: "Color Dreams",
      aliases: [
        "カラードリーム",
        "カラードリームス",
        "Color Dream",
        "Color Dreams",
        "Colour Dream",
        "Colour Dreams"
      ]
    },

    {
      id: "vegas",
      brand: "franck-muller",
      canonical: "Vegas",
      aliases: [
        "ヴェガス",
        "ベガス",
        "Vegas",
        "Franck Muller Vegas",
        "Frank Muller Vegas"
      ]
    },

    {
      id: "conquistador",
      brand: "franck-muller",
      canonical: "Conquistador",
      aliases: [
        "コンキスタドール",
        "Conquistador"
      ]
    },


    /* ================= ROLEX ================= */

    {
      id: "datejust",
      brand: "rolex",
      canonical: "Datejust",
      aliases: [
        "デイトジャスト",
        "Datejust",
        "Date Just",
        "Rolex Datejust"
      ]
    },

    {
      id: "oyster-perpetual",
      brand: "rolex",
      canonical: "Oyster Perpetual",
      aliases: [
        "オイスターパーペチュアル",
        "オイパペ",
        "Oyster Perpetual",
        "Rolex Oyster Perpetual"
      ]
    },

    {
      id: "cellini",
      brand: "rolex",
      canonical: "Cellini",
      aliases: [
        "チェリーニ",
        "Cellini",
        "Rolex Cellini"
      ]
    },


    /* ================= PATEK PHILIPPE ================= */

    {
      id: "calatrava",
      brand: "patek-philippe",
      canonical: "Calatrava",
      aliases: [
        "カラトラバ",
        "Calatrava",
        "Patek Calatrava",
        "Patek Philippe Calatrava"
      ]
    },

    {
      id: "golden-ellipse",
      brand: "patek-philippe",
      canonical: "Golden Ellipse",
      aliases: [
        "ゴールデンエリプス",
        "エリプス",
        "Golden Ellipse",
        "Ellipse",
        "Patek Golden Ellipse"
      ]
    },


    /* ================= HERMES ================= */

    {
      id: "nantucket",
      brand: "hermes",
      canonical: "Nantucket",
      aliases: [
        "ナンタケット",
        "Nantucket",
        "Hermes Nantucket",
        "Hermès Nantucket"
      ]
    },

    {
      id: "cape-cod",
      brand: "hermes",
      canonical: "Cape Cod",
      aliases: [
        "ケープコッド",
        "Cape Cod",
        "CapeCod",
        "Hermes Cape Cod",
        "Hermès Cape Cod"
      ]
    },

    {
      id: "heure-h",
      brand: "hermes",
      canonical: "Heure H",
      aliases: [
        "Hウォッチ",
        "アッシュウォッチ",
        "Heure H",
        "H Watch",
        "Hermes Heure H",
        "Hermès Heure H"
      ]
    },

    {
      id: "kelly",
      brand: "hermes",
      canonical: "Kelly",
      aliases: [
        "ケリー",
        "Kelly",
        "Hermes Kelly",
        "Hermès Kelly"
      ]
    }

  ],


  /* =========================================================
     PARENT GROUPS
     特定モデルではなくシリーズ全体
     ========================================================= */

  groups: [

    {
      id: "must-family",
      brand: "cartier",
      canonical: "Must",
      aliases: [
        "マスト",
        "Must",
        "Must de Cartier"
      ]
    },

    {
      id: "tank-family",
      brand: "cartier",
      canonical: "Tank",
      aliases: [
        "タンク",
        "Tank",
        "Cartier Tank"
      ]
    },

    {
      id: "santos-family",
      brand: "cartier",
      canonical: "Santos",
      aliases: [
        "サントス",
        "Santos",
        "Cartier Santos"
      ]
    }

  ],


  /* =========================================================
     SIZES
     ========================================================= */

  sizes: [

    {
      id: "mini",
      canonical: "Mini",
      aliases: [
        "ミニ",
        "Mini",
        "Mini Model"
      ]
    },

    {
      id: "sm",
      canonical: "SM",
      aliases: [
        "SM",
        "Small",
        "Small Model",
        "スモール"
      ]
    },

    {
      id: "mm",
      canonical: "MM",
      aliases: [
        "MM",
        "Medium",
        "Medium Model",
        "ミディアム"
      ]
    },

    {
      id: "lm",
      canonical: "LM",
      aliases: [
        "LM",
        "Large",
        "Large Model",
        "ラージ"
      ]
    },

    {
      id: "xl",
      canonical: "XL",
      aliases: [
        "XL",
        "Extra Large",
        "Extra-Large",
        "エクストララージ"
      ]
    }

  ],


  /* =========================================================
     MATERIALS
     ========================================================= */

  materials: [

    {
      id: "yg",
      canonical: "YG",
      aliases: [
        "YG",
        "Yellow Gold",
        "イエローゴールド"
      ]
    },

    {
      id: "wg",
      canonical: "WG",
      aliases: [
        "WG",
        "White Gold",
        "ホワイトゴールド"
      ]
    },

    {
      id: "pg",
      canonical: "PG",
      aliases: [
        "PG",
        "Pink Gold",
        "Rose Gold",
        "RG",
        "ピンクゴールド",
        "ローズゴールド"
      ]
    },

    {
      id: "ss",
      canonical: "SS",
      aliases: [
        "SS",
        "Stainless Steel",
        "Stainless",
        "Steel",
        "ステンレス",
        "ステンレススチール"
      ]
    },

    {
      id: "two-tone",
      canonical: "Two Tone",
      aliases: [
        "コンビ",
        "Two Tone",
        "Two-Tone",
        "TwoTone",
        "Bicolor",
        "Bi-Color",
        "バイカラー"
      ]
    }

  ],


  /* =========================================================
     DIAL COLORS
     文字盤カラー
     ========================================================= */

  dialColors: [

    {
      id: "ivory",
      canonical: "Ivory",
      aliases: [
        "アイボリー",
        "Ivory",
        "Ivory Dial"
      ]
    },

    {
      id: "white",
      canonical: "White",
      aliases: [
        "ホワイト",
        "白",
        "White",
        "White Dial"
      ]
    },

    {
      id: "black",
      canonical: "Black",
      aliases: [
        "ブラック",
        "黒",
        "Black",
        "Black Dial"
      ]
    },

    {
      id: "blue",
      canonical: "Blue",
      aliases: [
        "ブルー",
        "青",
        "Blue",
        "Blue Dial"
      ]
    },

    {
      id: "burgundy",
      canonical: "Burgundy",
      aliases: [
        "ボルドー",
        "バーガンディ",
        "Bordeaux",
        "Burgundy",
        "Burgundy Dial"
      ]
    },

    {
      id: "red",
      canonical: "Red",
      aliases: [
        "レッド",
        "赤",
        "Red",
        "Red Dial"
      ]
    },

    {
      id: "silver",
      canonical: "Silver",
      aliases: [
        "シルバー",
        "銀",
        "Silver",
        "Silver Dial"
      ]
    },

    {
      id: "champagne",
      canonical: "Champagne",
      aliases: [
        "シャンパン",
        "シャンパンゴールド",
        "Champagne",
        "Champagne Dial"
      ]
    },

    {
      id: "gold",
      canonical: "Gold",
      aliases: [
        "ゴールド文字盤",
        "Gold Dial"
      ]
    },

    {
      id: "grey",
      canonical: "Grey",
      aliases: [
        "グレー",
        "グレイ",
        "Grey",
        "Gray",
        "Grey Dial",
        "Gray Dial"
      ]
    }

  ]

};
/*
 * ============================================================
 * ANTE SEARCH DICTIONARY V4 - MULTILINGUAL ALIAS PATCH
 * ============================================================
 * Add this block at the END of ante-search-dictionary.js.
 *
 * Keeps all existing V3 aliases and adds Korean,
 * Simplified Chinese and Traditional Chinese aliases.
 * ============================================================
 */

(function () {
  "use strict";

  var dictionary = window.ANTE_SEARCH_DICTIONARY;
  if (!dictionary) return;

  var EXTRA_ALIASES = {
    /* BRANDS */
    "cartier": ["까르띠에", "卡地亚", "卡地亞"],
    "jaeger-lecoultre": ["예거 르쿨트르", "예거르쿨트르", "积家", "積家"],
    "franck-muller": ["프랭크 뮬러", "프랭크뮬러", "法兰克穆勒", "法蘭克穆勒"],
    "rolex": ["롤렉스", "劳力士", "勞力士"],
    "patek-philippe": ["파텍 필립", "파텍필립", "百达翡丽", "百達翡麗"],
    "hermes": ["에르메스", "爱马仕", "愛馬仕"],

    /* CARTIER */
    "panthere": ["팬더", "팬테르", "팡테르", "猎豹", "獵豹", "卡地亚猎豹", "卡地亞獵豹"],
    "panthere-cougar": ["팬더 쿠거", "팬테르 쿠거", "쿠거", "美洲豹", "库加", "庫加"],

    "must-tank": ["머스트 탱크", "머스트탱크", "坦克Must", "Must坦克", "坦克 Must"],
    "pre-must-tank": ["프리 머스트", "프리머스트", "프리 머스트 탱크", "前Must坦克", "前期Must坦克"],

    "tank-louis": ["탱크 루이", "탱크루이", "루이 까르띠에 탱크", "路易坦克", "路易卡地亚坦克", "路易卡地亞坦克"],
    "tank-francaise": ["탱크 프랑세즈", "탱크프랑세즈", "法式坦克", "法国坦克", "法國坦克"],
    "tank-americaine": ["탱크 아메리칸", "탱크아메리칸", "美国坦克", "美國坦克"],
    "tank-anglaise": ["탱크 앙글레즈", "탱크앙글레즈", "英国坦克", "英國坦克"],
    "tank-basculante": ["탱크 바스큘란트", "탱크바스큘란트", "翻转坦克", "翻轉坦克"],
    "tank-solo": ["탱크 솔로", "탱크솔로", "坦克Solo", "Solo坦克"],

    "baignoire": ["베누아", "베누아르", "浴缸", "浴缸系列"],
    "baignoire-allongee": ["베누아 알롱제", "알롱제", "加长浴缸", "加長浴缸"],

    "santos-galbee": ["산토스 갈베", "산토스갈베", "山度士Galbée", "山度士Galbee"],
    "santos-octagon": ["산토스 옥타곤", "산토스옥타곤", "山度士八角", "山度士八角形"],
    "santos-demoiselle": ["산토스 드모아젤", "산토스 데모아젤", "드모아젤", "山度士Demoiselle"],
    "santos-dumont": ["산토스 뒤몽", "산토스뒤몽", "山度士杜蒙", "山度士-杜蒙"],

    "ballon-bleu": ["발롱 블루", "발롱블루", "蓝气球", "藍氣球"],
    "tortue": ["토르튀", "토르투", "龟形", "龜形"],
    "trinity": ["트리니티", "三色金", "三环", "三環"],
    "roadster": ["로드스터", "跑车", "跑車"],
    "vendome": ["방돔", "벤돔", "旺多姆"],
    "colisee": ["콜리제", "콜리세", "竞技场", "競技場"],
    "pasha": ["파샤", "帕莎"],
    "diabolo": ["디아볼로", "迪亚波罗", "迪亞波羅"],
    "tonneau": ["토노", "酒桶", "酒桶形"],
    "ronde": ["롱드", "伦敦", "倫敦", "圆形", "圓形"],

    /* JAEGER-LECOULTRE */
    "reverso": ["리베르소", "레베르소", "翻转", "翻轉", "Reverso翻转", "Reverso翻轉"],
    "reverso-duetto": ["리베르소 듀에토", "듀에토", "翻转Duetto", "翻轉Duetto"],
    "reverso-classique": ["리베르소 클래식", "리베르소 클래식크", "翻转经典", "翻轉經典"],

    /* FRANCK MULLER */
    "casablanca": ["카사블랑카", "卡萨布兰卡", "卡薩布蘭卡"],
    "long-island": ["롱 아일랜드", "롱아일랜드", "长岛", "長島"],
    "tonneau-curvex": ["토노 커벡스", "토노커벡스", "酒桶Curvex"],
    "color-dreams": ["컬러 드림", "컬러드림", "彩色梦想", "彩色夢想"],
    "vegas": ["베가스", "拉斯维加斯", "拉斯維加斯"],
    "conquistador": ["콘키스타도르", "征服者"],

    /* ROLEX */
    "datejust": ["데이트저스트", "日志型", "日誌型"],
    "oyster-perpetual": ["오이스터 퍼페츄얼", "오이스터퍼페츄얼", "蚝式恒动", "蠔式恆動"],
    "cellini": ["첼리니", "切利尼"],

    /* PATEK PHILIPPE */
    "calatrava": ["칼라트라바", "卡拉卓华", "卡拉卓華"],
    "golden-ellipse": ["골든 엘립스", "골든엘립스", "黄金椭圆", "黃金橢圓"],

    /* HERMES */
    "nantucket": ["난투켓", "南塔ケット", "南塔克特"],
    "cape-cod": ["케이프 코드", "케이프코드", "Cape Cod"],
    "heure-h": ["아워 H", "에르 H", "H小时", "H小時"],
    "kelly": ["켈리", "凯莉", "凱莉"]
  };

  function addAliases(items) {
    if (!Array.isArray(items)) return;

    items.forEach(function (item) {
      var additions = EXTRA_ALIASES[item.id];
      if (!additions || !additions.length) return;

      if (!Array.isArray(item.aliases)) {
        item.aliases = [];
      }

      additions.forEach(function (alias) {
        if (item.aliases.indexOf(alias) === -1) {
          item.aliases.push(alias);
        }
      });
    });
  }

  addAliases(dictionary.brands);
  addAliases(dictionary.models);

  console.info("ANTE Search Dictionary V4 multilingual aliases loaded.");
})();
